module.exports = __webpack_public_path__ + "img/product1@2x.ccb6ae70.png";